import { WORDS } from '../constants/wordlist'
import { WRONG_SPOT_MESSAGE, NOT_CONTAINED_MESSAGE } from '../constants/strings'
import { getGuessStatuses } from './statuses'
import { default as GraphemeSplitter } from 'grapheme-splitter'

const msInDay = 86400000
export const firstGameDateKey = '2022-02-24'

export const isWordInWordList = (word: string) => {
  return WORDS.includes(word)
}

export const isWinningWord = (word: string, solution: string) => {
  return solution === word
}

// build a set of previously revealed letters - present and correct
// guess must use correct letters in that space and any other revealed letters
// also check if all revealed instances of a letter are used (i.e. two C's)
export const findFirstUnusedReveal = (
  word: string,
  guesses: string[],
  solution: string
) => {
  if (guesses.length === 0) {
    return false
  }

  const lettersLeftArray = new Array<string>()
  const guess = guesses[guesses.length - 1]
  const statuses = getGuessStatuses(guess, solution)

  for (let i = 0; i < guess.length; i++) {
    if (statuses[i] === 'correct' || statuses[i] === 'present') {
      lettersLeftArray.push(guess[i])
    }
    if (statuses[i] === 'correct' && word[i] !== guess[i]) {
      return WRONG_SPOT_MESSAGE(guess[i], i + 1)
    }
  }

  // check for the first unused letter, taking duplicate letters
  // into account - see issue #198
  let n
  for (const letter of word) {
    n = lettersLeftArray.indexOf(letter)
    if (n !== -1) {
      lettersLeftArray.splice(n, 1)
    }
  }

  if (lettersLeftArray.length > 0) {
    return NOT_CONTAINED_MESSAGE(lettersLeftArray[0])
  }
  return false
}

export const unicodeSplit = (word: string) => {
  return new GraphemeSplitter().splitGraphemes(word)
}

export const unicodeLength = (word: string) => {
  return unicodeSplit(word).length
}

// export const localeAwareLowerCase = (text: string) => {
//   return process.env.REACT_APP_LOCALE_STRING
//     ? text.toLocaleLowerCase(process.env.REACT_APP_LOCALE_STRING)
//     : text.toLowerCase()
// }

// export const localeAwareUpperCase = (text: string) => {
//   return process.env.REACT_APP_LOCALE_STRING
//     ? text.toLocaleUpperCase(process.env.REACT_APP_LOCALE_STRING)
//     : text.toUpperCase()
// }

const parseDateKey = (dateKey: string) => {
  const [year, month, day] = dateKey.split('-').map(Number)
  return new Date(year, month - 1, day)
}

const toDateKey = (date: Date) => {
  const year = date.getFullYear()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const getTodayDateKey = () => toDateKey(new Date())

export const normalizeDateKey = (dateKey: string) => {
  const date = parseDateKey(dateKey)

  if (Number.isNaN(date.valueOf()) || toDateKey(date) !== dateKey) {
    return getTodayDateKey()
  }

  if (dateKey < firstGameDateKey) {
    return firstGameDateKey
  }

  const todayDateKey = getTodayDateKey()
  if (dateKey > todayDateKey) {
    return todayDateKey
  }

  return dateKey
}

export const getGameDay = (dateKey = getTodayDateKey()) => {
  const normalizedDateKey = normalizeDateKey(dateKey)
  const epochMs = parseDateKey(firstGameDateKey).valueOf()
  const gameDayMs = parseDateKey(normalizedDateKey).valueOf()
  const index = Math.floor((gameDayMs - epochMs) / msInDay)
  const nextDay = (index + 1) * msInDay + epochMs

  return {
    solution: WORDS[index % WORDS.length],
    solutionIndex: index,
    dateKey: normalizedDateKey,
    nextDay,
  }
}
